import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { toast } from 'react-toastify';
import _ from 'lodash';
import RSelect from 'react-select';
import Textarea from 'react-expanding-textarea';
import CircularProgress from './../../../../components/CircularProgress';
import PaginationComponent from './../../../common/Pagination';
import { GET_REPORT_DATA, MARK_IGNORED_DATA, Revert_Ignored_DATA, UPDATE_DESCRIPTION_DATA, IGNORE_VENDOR, UNIGNORE_VENDOR } from '../../../../appRedux/actions/ReportDetailAction';
import { LedgerUpdate, UpdateBatchNewAccount } from '../../../../appRedux/actions/LedgerAction';
import { Accounts } from '../../../../appRedux/actions/accountAction';
import { ReportType, numberWithCommas, makeLinkForQuickbooks, ModuleType, LinkType } from '../../../common/commonServices';
import { accountSelectMenuProps } from '../../../common/transactionEdit';
import CommonComments from './../../../common/Comments';
import '../../styles.css';
import './DataEntryIssues.css';

// Review Inconsistent Expense Coding (ReportType 54) — TBR edit row + GL Review CPA.
const FontTooltip = withStyles(() => ({
    tooltip: {
        fontSize: 12
    },
}))(Tooltip);

const newAccountSelectStyles = {
    control: base => ({ ...base, minHeight: 38 }),
    valueContainer: base => ({ ...base, overflow: 'visible' }),
    singleValue: base => ({ ...base, overflow: 'visible', textOverflow: 'clip', maxWidth: '100%' }),
    menuPortal: base => Object.assign({}, base, { zIndex: 9999 }),
    menu: base => ({ ...base, zIndex: 9999 })
};

class ReviewInconsistentExpenseCoding extends Component {

    constructor(props) {
        super(props);

        this.state = {
            MissingData: [],
            companyId: 0,
            sortField: 'vendor',
            sortFormat: 'A',
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#46b29d",
            sDate: new Date(2019, 0, 1),
            eDate: new Date(),
            loading: false,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: false,
            SelectedRecords: [],
            SelectALL: false,
            IsIgnoredFilter: false,
            ShowIgnoredVendors: false,
            IsCommentModelOpen: false,
            editIndex: -1,
            editData: null,
            selectedAccount: null,
            accounts: [],
            DisplayAccounts: [],
            pendingDescriptionBody: null,
            pendingVendorIgnore: null,   // { glId, ignore } applied after the row save
            pendingTfbOnlySave: false,
            selectedBatchAccountId: { value: 0, label: "Select" }
        }
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.props.Accounts(this.state.companyId);
            this.GetReportData();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                let data = nextProps.ReportData.returnObject || [];
                let totalrecords = data.length > 0 ? data[0].totalrows : 0;
                this.setState({ MissingData: data, TotalRecords: totalrecords, loading: false, SelectALL: false, SelectedRecords: [], editIndex: -1, editData: null });
            } else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }

        // Fired by Got It / Revert and by the memo save that follows LedgerUpdate.
        if (nextProps.UpdateDescription !== this.props.UpdateDescription) {
            const isMemoSave = !!this.state.pendingDescriptionBody;
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                if (isMemoSave) {
                    this.completeRowSave("Transaction updated successfully", { SelectALL: false, SelectedRecords: [] });
                } else {
                    this.setState({ loading: true, SelectALL: false, SelectedRecords: [], editIndex: -1, editData: null, pendingDescriptionBody: null }, () => {
                        toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                        this.GetReportData();
                    });
                }
            }
            else {
                this.setState({ loading: false, pendingDescriptionBody: null, pendingVendorIgnore: null }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }

        if (nextProps.LEDGER_UPDATE !== undefined && nextProps.LEDGER_UPDATE !== this.props.LEDGER_UPDATE) {
            if (nextProps.LEDGER_UPDATE.transactionStatus === 0) {
                if (this.state.pendingDescriptionBody) {
                    this.props.UPDATE_DESCRIPTION_DATA(this.state.pendingDescriptionBody);
                } else {
                    this.completeRowSave(this.state.pendingTfbOnlySave ? "TFB updated successfully." : "Transaction updated successfully");
                }
            }
            else {
                this.setState({ loading: false, editIndex: -1, editData: null, selectedAccount: null, pendingDescriptionBody: null, pendingTfbOnlySave: false, pendingVendorIgnore: null }, () => {
                    toast.error(nextProps.LEDGER_UPDATE.resultMsg || "Update failed");
                });
            }
        }

        // Batch New Account (same endpoint as Review Uncategorized Transactions).
        if (nextProps.BATCH_LEDGER_UPDATE != undefined && nextProps.BATCH_LEDGER_UPDATE !== this.props.BATCH_LEDGER_UPDATE) {
            if (nextProps.BATCH_LEDGER_UPDATE.transactionStatus === 0) {
                this.setState({ loading: true, editIndex: -1, editData: null, SelectedRecords: [], SelectALL: false, selectedBatchAccountId: { value: 0, label: "Select" } }, () => {
                    toast.success("Record updated successfully");
                    this.GetReportData();
                });
            }
            else {
                this.setState({ loading: false }, () => {
                    toast.error(nextProps.BATCH_LEDGER_UPDATE.resultMsg || "Batch update failed. Please try again.");
                });
            }
        }

        if (nextProps.accounts !== this.props.accounts) {
            if (nextProps.accounts && nextProps.accounts.data != null && nextProps.accounts.data.length > 0) {
                let searchableAccounts = _.sortBy(nextProps.accounts.data, ['accountNumber', 'name']).map((value) => (
                    { value: value.accountID, label: (value.accountNumber != null ? value.accountNumber + ' ' + value.name : value.name) }
                ));
                searchableAccounts.unshift({ value: 0, label: 'Select' });
                this.setState({ accounts: nextProps.accounts.data, DisplayAccounts: searchableAccounts });
            }
        }
    }

    GetReportData = () => {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.ReviewInconsistentExpenseCoding,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: false,
            IsIgnore: true,
            isAllIgnoreUnignore: state.IsIgnoredFilter,
            showIgnoredVendors: state.ShowIgnoredVendors
        };

        this.props.GET_REPORT_DATA(body);
    }

    onCheckboxClick = (e, item) => {
        e.stopPropagation();
        let data = this.state.SelectedRecords;
        let index = data.indexOf(item.id);
        if (e.target.checked && index === -1) {
            data.push(item.id);
        }
        else if (!e.target.checked && index > -1) {
            data.splice(index, 1);
        }
        this.setState({ SelectedRecords: data, SelectALL: data.length === this.state.MissingData.length });
    }

    SelectALL = (e) => {
        if (this.state.MissingData.length > 0) {
            if (e.target.checked) {
                this.setState({ SelectALL: true, SelectedRecords: this.state.MissingData.map(x => x.id) });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }

    OnApplyIgnore = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        let body = {
            "ids": selectedData,
            "reportType": ReportType.ReviewInconsistentExpenseCoding,
            "companyID": this.state.companyId
        }

        this.setState({ loading: true }, () => {
            if (this.state.IsIgnoredFilter) {
                this.props.Revert_Ignored_DATA(body);
            }
            else {
                this.props.MARK_IGNORED_DATA(body);
            }
        });
    }

    OnAssignNewAccount = () => {
        const selectedData = this.state.SelectedRecords;
        const selectedBatchAccountId = this.state.selectedBatchAccountId;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }
        if (selectedBatchAccountId == null || selectedBatchAccountId.value == null || selectedBatchAccountId.value == 0) {
            toast.error("Please select account");
            return false;
        }

        const body = {
            "companyID": this.state.companyId,
            "txnId": selectedBatchAccountId.value,
            "glIds": selectedData
        };

        this.setState({ loading: true }, () => {
            this.props.UpdateBatchNewAccount(body);
        });
    }

    handalBatchUpdateAccountDropdown = (e) => {
        this.setState({ selectedBatchAccountId: e });
    }

    // The two ignored views are exclusive: turning one on turns the other off.
    HandleIgnored = (event) => {
        const isIgnored = event.target.value === "true";
        this.setState({ IsIgnoredFilter: isIgnored, ShowIgnoredVendors: isIgnored ? false : this.state.ShowIgnoredVendors, PageNo: 1, loading: true, SelectedRecords: [], SelectALL: false, editIndex: -1, editData: null }, () => { this.GetReportData() });
    }

    HandleShowIgnoredVendors = (event) => {
        const showVendors = event.target.value === "true";
        this.setState({ ShowIgnoredVendors: showVendors, IsIgnoredFilter: showVendors ? false : this.state.IsIgnoredFilter, PageNo: 1, loading: true, SelectedRecords: [], SelectALL: false, editIndex: -1, editData: null }, () => { this.GetReportData() });
    }

    // Ignore / restore the vendor of one GL row; resolves to the API message, or null on failure.
    applyVendorIgnore = (glId, ignore) => {
        const body = { companyID: this.state.companyId, reportType: ReportType.RIECIgnoreVendor, glIds: [glId] };
        return (ignore ? this.props.IGNORE_VENDOR(body) : this.props.UNIGNORE_VENDOR(body))
            .then((result) => {
                if (result && result.transactionStatus === 0) return result.resultMsg;
                toast.error((result && result.resultMsg) || 'Unable to update the vendor.');
                return null;
            })
            .catch(() => null);
    }

    // Ends an edit-row save: applies a pending Ignore Vendor change, then toasts and reloads.
    completeRowSave = (message, extraState = {}) => {
        const pending = this.state.pendingVendorIgnore;
        const finish = (vendorMessage) => this.setState({ loading: true, editIndex: -1, editData: null, selectedAccount: null, pendingDescriptionBody: null, pendingTfbOnlySave: false, pendingVendorIgnore: null, ...extraState }, () => {
            if (message) toast.success(message);
            if (vendorMessage) toast.success(vendorMessage);
            this.GetReportData();
        });
        if (!pending) return finish(null);
        this.applyVendorIgnore(pending.glId, pending.ignore).then(finish);
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField === fieldName) {
            this.setState({ sortFormat: this.state.sortFormat === 'A' ? 'D' : 'A', loading: true }, () => { this.GetReportData(); });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => { this.GetReportData(); });
        }
    }

    ChangePageSize = (size) => {
        this.setState({ loading: true, PageSize: parseInt(size), PageNo: 1, SelectedRecords: [], SelectALL: false, editIndex: -1, editData: null }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({ loading: true, PageNo: page, SelectedRecords: [], SelectALL: false, editIndex: -1, editData: null }, () => {
            this.GetReportData();
        });
    }

    onLinkClick = (e, rowData) => {
        e.stopPropagation();
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }

    LoadComments = (e, item) => {
        e.stopPropagation();
        this.setState({ IsCommentModelOpen: true, CommentReferenceId: item.id });
    }

    UpdateItemCommentCount = (id, clearUnread) => {
        let data = this.state.MissingData;
        data.forEach(function (item) {
            if (item.id === id) {
                if (clearUnread === true) { item.unreviewCommentCount = 0; } else { item.commentCount++ }
            }
        });
        this.setState({ MissingData: data });
    }

    CloseComments = () => {
        this.setState({ IsCommentModelOpen: false });
    }

    formatNewAccountLabel = (item) => {
        if (item.newAccountName != null && String(item.newAccountName).trim() !== '') {
            return String(item.newAccountName).trim();
        }
        if (item.newAccountId && this.state.accounts.length > 0) {
            const acc = this.state.accounts.find(x => x.accountID == item.newAccountId);
            if (acc) return acc.accountNumber != null ? `${acc.accountNumber} ${acc.name}` : acc.name;
        }
        return '';
    }

    onRowClick = (j, item) => {
        let selectedAccount = { value: 0, label: "Select" };
        if (item.newAccountId) {
            selectedAccount = this.state.DisplayAccounts.find(x => String(x.value) === String(item.newAccountId)) || selectedAccount;
        }
        this.setState({
            editIndex: j,
            editData: {
                needsBetterDescription: !!item.needsBetterDescription,
                taxableFringeBenefit: !!item.taxableFringeBenefit,
                cpaReview: !!item.cpaReview,
                accountantComment: item.accountantComment || '',
                internalNotes: item.internalNotes || '',
                memoOrDescription: item.memoOrDescription || '',
                newAccountId: item.newAccountId || '',
                ignoreVendor: !!this.state.ShowIgnoredVendors   // rows in that view belong to ignored vendors
            },
            selectedAccount: selectedAccount
        });
    }

    onRowCancel = () => {
        this.setState({ editIndex: -1, editData: null, selectedAccount: null });
    }

    handalTextArea = (e) => {
        let editData = { ...this.state.editData };
        editData[e.target.name] = e.target.value;
        this.setState({ editData: editData });
    }

    handalCheckbox = (e) => {
        let editData = { ...this.state.editData };
        editData[e.target.name] = e.target.checked;
        this.setState({ editData: editData });
    }

    handalAccountDropdown = (e) => {
        let editData = { ...this.state.editData };
        editData.newAccountId = (e.value == null || e.value == 0) ? '' : e.value;
        this.setState({ editData: editData, selectedAccount: e });
    }

    buildLedgerPayload = (item, overrides) => ({
        id: item.id,
        transactionTypeId: item.transactionTypeId || 0,
        transactionType: item.transactionType,
        accountId: item.accountId || 0,
        newAccountId: item.newAccountId && Number(item.newAccountId) > 0 ? Number(item.newAccountId) : 0,
        needsBetterDescription: !!item.needsBetterDescription,
        transferCodedIncorrectly: !!item.transferCodedIncorrectly,
        cpaReview: !!item.cpaReview,
        pcCheck: !!item.pcCheck,
        accountantComment: item.accountantComment || '',
        internalNotes: item.internalNotes || '',
        taxableFringeBenefit: !!item.taxableFringeBenefit,
        vendor1099: !!item.vendor1099,
        taxReporting: !!item.taxReporting,
        isArchived: !!item.isArchived,
        benefitTypeId: item.benefitTypeId || 0,
        employeeName: item.employeeName || '',
        clientComment: item.clientComment || '',
        accountChangeApprovedByClient: !!item.accountChangeApprovedByClient,
        clientReviewStatus: !!item.clientReviewStatus,
        accountantReviewStatus: !!item.accountantReviewStatus,
        descriptionNeedsEmployeeName: !!item.descriptionNeedsEmployeeName,
        clientApprovedTaxableFringeBenefit: !!item.clientApprovedTaxableFringeBenefit,
        accountantPostedTaxableFringeBenefit: !!item.accountantPostedTaxableFringeBenefit,
        memoOrDescription: item.memoOrDescription || '',
        ...overrides
    })

    // TFB-only save when TFB is the only change; otherwise a full LedgerUpdate (TFB included), then
    // UpdateDescription (QBO memo) only when the memo changed — so no edit is dropped.
    onRowSave = (item) => {
        const editData = this.state.editData;
        const newAccountId = editData.newAccountId && Number(editData.newAccountId) > 0 ? Number(editData.newAccountId) : 0;
        const rowNewAccountId = item.newAccountId && Number(item.newAccountId) > 0 ? Number(item.newAccountId) : 0;
        const tfbChanged = !!item.taxableFringeBenefit !== !!editData.taxableFringeBenefit;
        const otherChanged = newAccountId !== rowNewAccountId
            || !!item.needsBetterDescription !== !!editData.needsBetterDescription
            || !!item.cpaReview !== !!editData.cpaReview
            || (item.accountantComment || '') !== (editData.accountantComment || '')
            || (item.internalNotes || '') !== (editData.internalNotes || '')
            || (item.memoOrDescription || '') !== (editData.memoOrDescription || '');
        const vendorChanged = !this.state.IsIgnoredFilter && !!editData.ignoreVendor !== !!this.state.ShowIgnoredVendors;
        const pendingVendorIgnore = vendorChanged ? { glId: item.id, ignore: !!editData.ignoreVendor } : null;

        if (vendorChanged && !tfbChanged && !otherChanged) {
            this.setState({ loading: true, pendingVendorIgnore }, () => this.completeRowSave(null));
            return;
        }

        if (tfbChanged && !otherChanged) {
            const data = this.buildLedgerPayload(item, { taxableFringeBenefit: !!editData.taxableFringeBenefit, updateTaxableFringeBenefitOnly: true });
            this.setState({ loading: true, pendingDescriptionBody: null, pendingTfbOnlySave: true, pendingVendorIgnore }, () => {
                this.props.LedgerUpdate(data, this.state.companyId, "TFB updated successfully.");
            });
            return;
        }

        const data = this.buildLedgerPayload(item, {
            newAccountId: newAccountId,
            needsBetterDescription: !!editData.needsBetterDescription,
            taxableFringeBenefit: !!editData.taxableFringeBenefit,
            cpaReview: !!editData.cpaReview,
            accountantComment: editData.accountantComment,
            internalNotes: editData.internalNotes,
            memoOrDescription: editData.memoOrDescription
        });

        const memoChanged = (editData.memoOrDescription || '') !== (item.memoOrDescription || '');
        const descriptionBody = memoChanged ? {
            id: item.id,
            memoOrDescription: editData.memoOrDescription,
            reportType: ReportType.ReviewInconsistentExpenseCoding,
            createdByName: null
        } : null;

        this.setState({ loading: true, pendingDescriptionBody: descriptionBody, pendingTfbOnlySave: false, pendingVendorIgnore }, () => {
            this.props.LedgerUpdate(data, this.state.companyId, "Transaction updated successfully.");
        });
    }

    sortHeader = (field, title, extraClass = '') => (
        <th className={`td-width ${extraClass} ${this.state.sortField === field ? (this.state.sortFormat === 'A' ? "asending" : "desending") : ''}`} onClick={() => this.onSortChange(field)}>
            <p className="table-th-title">{title}</p>
        </th>
    )

    renderEditRows = (item, j) => {
        const editData = this.state.editData;
        return (
            <React.Fragment>
                <tr className="editRowColor riec-edit-row-1">
                    <td colSpan="15" className="riec-edit-cell">
                        <div className="riec-edit-inner riec-edit-row-1-inner">
                            <div className="riec-edit-stack riec-edit-account">
                                <label>New Account</label>
                                <RSelect
                                    name="NewAccountID"
                                    value={this.state.selectedAccount}
                                    onChange={(e) => this.handalAccountDropdown(e)}
                                    options={this.state.DisplayAccounts}
                                    placeholder="Select"
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    styles={newAccountSelectStyles}
                                />
                            </div>
                            <div className="riec-edit-stack riec-edit-memo">
                                <label>Memo/Description</label>
                                <Textarea className="placheholder-color riec-edit-textarea"
                                    value={editData.memoOrDescription} name="memoOrDescription"
                                    resize={"false"} placeholder=""
                                    onChange={(e) => this.handalTextArea(e)} />
                            </div>
                            <div className="riec-edit-flags">
                                <div className="chiller_cb" style={{ marginBottom: 0 }}>
                                    <input id={`riec_tfb_${j}`} name="taxableFringeBenefit" type="checkbox" checked={!!editData.taxableFringeBenefit} onChange={this.handalCheckbox} />
                                    <label htmlFor={`riec_tfb_${j}`}><p className="checkbox-title">TFB</p></label>
                                    <span></span>
                                </div>
                                <FontTooltip id="tooltip-icon" title="Needs Better Description" placement="top">
                                    <div className="chiller_cb" style={{ marginBottom: 0 }}>
                                        <input id={`riec_nbd_${j}`} name="needsBetterDescription" type="checkbox" checked={!!editData.needsBetterDescription} onChange={this.handalCheckbox} />
                                        <label htmlFor={`riec_nbd_${j}`}><p className="checkbox-title">NBD</p></label>
                                        <span></span>
                                    </div>
                                </FontTooltip>
                                <FontTooltip id="tooltip-icon" title="CPA Review" placement="top">
                                    <div className="chiller_cb" style={{ marginBottom: 0 }}>
                                        <input id={`riec_cpa_${j}`} name="cpaReview" type="checkbox" checked={!!editData.cpaReview} onChange={this.handalCheckbox} />
                                        <label htmlFor={`riec_cpa_${j}`}><p className="checkbox-title">CPA</p></label>
                                        <span></span>
                                    </div>
                                </FontTooltip>
                                {!this.state.IsIgnoredFilter &&
                                    <FontTooltip id="tooltip-icon" title="Ignore all current and future transactions for this vendor" placement="top">
                                        <div className="chiller_cb" style={{ marginBottom: 0 }}>
                                            <input id={`riec_ignorevendor_${j}`} name="ignoreVendor" type="checkbox" checked={!!editData.ignoreVendor} onChange={this.handalCheckbox} />
                                            <label htmlFor={`riec_ignorevendor_${j}`}><p className="checkbox-title">Ignore Vendor</p></label>
                                            <span></span>
                                        </div>
                                    </FontTooltip>
                                }
                            </div>
                        </div>
                    </td>
                </tr>
                <tr className="editRowColor riec-edit-row-2">
                    <td colSpan="15" className="riec-edit-cell">
                        <div className="riec-edit-inner riec-edit-row-2-inner">
                            <div className="riec-edit-field riec-edit-field-qc">
                                <label className="riec-edit-label">Questions and Comments:</label>
                                <Textarea className="placheholder-color riec-edit-textarea"
                                    value={editData.accountantComment} name="accountantComment"
                                    resize={"false"} placeholder=""
                                    onChange={(e) => this.handalTextArea(e)} />
                            </div>
                            <div className="riec-edit-field">
                                <label className="riec-edit-label">Internal Notes:</label>
                                <Textarea className="placheholder-color riec-edit-textarea"
                                    value={editData.internalNotes} name="internalNotes"
                                    resize={"false"} placeholder=""
                                    onChange={(e) => this.handalTextArea(e)} />
                            </div>
                            <div className="riec-edit-actions">
                                <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowSave(item)}>SAVE</Button>
                                <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancel()}>CANCEL</Button>
                            </div>
                        </div>
                    </td>
                </tr>
            </React.Fragment>
        );
    }

    render() {
        let selectedItem = this.state.SelectedRecords;
        let user = JSON.parse(localStorage.getItem('userData'));
        return (
            <div className="dashboardPage data-entry-issues-page review-inconsistent-expense-coding-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{user != null ? user.companyName : ""} | {LinkType.ReviewInconsistentExpenseCoding}</h2>
                </div>
                {this.state.IsCommentModelOpen ? <CommonComments
                    CloseComments={this.CloseComments}
                    ColorCode={this.state.ColorCode}
                    ModuleType={ModuleType.GeneralReportType}
                    ReportType={ReportType.ReviewInconsistentExpenseCoding}
                    CompanyId={this.state.companyId}
                    RecordId={this.state.CommentReferenceId}
                    IsEmbeddedPage={this.state.IsEmbeddedPage}
                    UpdateItemCommentCount={this.UpdateItemCommentCount}
                    SilentRefreshData={() => { this.GetReportData(); }}
                ></CommonComments> : ""}                {this.state.loading ? <div className="dei-loader-box"><CircularProgress /></div>
                    :
                    <React.Fragment>
                        <div className="padding-box app-wrapper">
                            <div className="row mt-1">
                                <div className="col-md-4">
                                    {/* Training tip hidden for now (keep for later).
                                    <div className="dei-tip-block">
                                        <h5 className="dei-training-tip">Payments to these vendors are not all coded to the same expense account.</h5>
                                        <h5 className="dei-training-tip">Review each vendor's transactions and recode any that should use the same account.</h5>
                                        <h5 className="dei-training-tip">If the coding is correct, select the entries and click "Got It".</h5>
                                    </div>
                                    */}
                                </div>
                                <div className="col-md-8">
                                    <div className='d-flex justify-content-end align-items-end h-100'>
                                        <div className='d-flex align-items-center flex-wrap justify-content-end'>
                                            <div className='show-previously-box'>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <h4 className="col-form-label mb-0">Show Ignored Vendors:</h4>
                                                    <div className="dropdown-input-box">
                                                        <select className="dei-filter-select select-box arrow-box" onChange={this.HandleShowIgnoredVendors} value={this.state.ShowIgnoredVendors} >
                                                            <option value={true}> YES </option>
                                                            <option value={false}> NO </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='show-previously-box'>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <h4 className="col-form-label mb-0">Show Previously Ignored Transactions:</h4>
                                                    <div className="dropdown-input-box">
                                                        <select className="dei-filter-select select-box arrow-box" onChange={this.HandleIgnored} value={this.state.IsIgnoredFilter} >
                                                            <option value={true}> YES </option>
                                                            <option value={false}> NO </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {!this.state.ShowIgnoredVendors &&
                                                <div className='assign-vendor-box'>
                                                    <div className="form-group d-flex mb-0 align-items-center">
                                                        <h4 className="col-form-label mb-0">New Account:</h4>
                                                        <div className='rselect-box'>
                                                            <RSelect
                                                                name="BatchNewAccountID"
                                                                value={this.state.selectedBatchAccountId}
                                                                onChange={(e) => this.handalBatchUpdateAccountDropdown(e)}
                                                                options={this.state.DisplayAccounts}
                                                                placeholder="Select"
                                                                {...accountSelectMenuProps()}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="form-group d-flex mb-0 align-items-center">
                                                {!this.state.ShowIgnoredVendors &&
                                                    <React.Fragment>
                                                        <Button variant="contained" className=" jr-btn text-white refresh-btn graycolor" onClick={() => this.OnAssignNewAccount()}>Save</Button>
                                                        <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnApplyIgnore()}>{this.state.IsIgnoredFilter ? "Revert" : "Got It"}</Button>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive-material">
                                <table className="table tablebox account-reconcilliation riec-table">
                                    <thead>
                                        <tr style={{ backgroundColor: this.state.ColorCode }}>
                                            {this.sortHeader('date', 'Date')}
                                            {this.sortHeader('transactionType', 'Type')}
                                            {this.sortHeader('vendor', 'Vendor')}
                                            {this.sortHeader('account', 'Account')}
                                            {this.sortHeader('amount', 'Amount', 'text-right')}
                                            {this.sortHeader('memoOrDescription', 'Memo/Description')}
                                            {this.sortHeader('internalNotes', 'Internal Notes')}
                                            {this.sortHeader('accountantComment', 'Questions and Comments')}
                                            {this.sortHeader('newAccount', 'New Account #')}
                                            <th className="text-center riec-flag-col"><p className="table-th-title riec-flag-title">TFB</p></th>
                                            <th className="text-center riec-flag-col"><p className="table-th-title riec-flag-title">NBD</p></th>
                                            <th className="text-center riec-flag-col"><p className="table-th-title riec-flag-title">CPA</p></th>
                                            <th className="text-center">
                                                <label className="container101 header-check">
                                                    <input className="second-check-box" type="checkbox" checked={!!this.state.SelectALL} onChange={(e) => this.SelectALL(e)} />
                                                    <span className="checkmark101 yellowMark white_border"></span>
                                                </label>
                                            </th>
                                            <th className="text-center">
                                                <div className="panel-commentCount" style={{ width: 'auto', display: 'inline-block', margin: 0, verticalAlign: 'middle' }}>
                                                    <img src="/vendors/WhiteCommnet.png" alt="comments" />
                                                </div>
                                            </th>
                                            <th className="text-center"><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.MissingData && this.state.MissingData.length > 0 ?
                                            this.state.MissingData.map((item, j) => (
                                                <React.Fragment key={item.id}>
                                                    <tr onClick={() => this.onRowClick(j, item)} className="dei-clickable">
                                                        <td title={item.date || ''}>{item.date}</td>
                                                        <td title={item.transactionType || ''}>{item.transactionType}</td>
                                                        <td title={item.name || ''}>{item.name}</td>
                                                        <td title={item.account || ''}>{item.account}</td>
                                                        <td className="text-right" title={item.amount != null ? String(item.amount) : ''}>{numberWithCommas(item.amount)}</td>
                                                        <td title={item.memoOrDescription || ''}>{item.memoOrDescription}</td>
                                                        <td title={item.internalNotes || ''}>{item.internalNotes}</td>
                                                        <td title={item.accountantComment || ''}>{item.accountantComment}</td>
                                                        <td title={this.formatNewAccountLabel(item)}>{this.formatNewAccountLabel(item)}</td>
                                                        <td className="text-center">{item.taxableFringeBenefit ?
                                                            <FontTooltip id="tooltip-icon" title="Taxable Fringe Benefit" placement="top-start">
                                                                <i className="zmdi zmdi-check"></i>
                                                            </FontTooltip>
                                                            : ''}</td>
                                                        <td className="text-center">{item.needsBetterDescription ?
                                                            <FontTooltip id="tooltip-icon" title="Needs Better Description" placement="top-start">
                                                                <i className="zmdi zmdi-check"></i>
                                                            </FontTooltip>
                                                            : ''}</td>
                                                        <td className="text-center">{item.cpaReview ?
                                                            <FontTooltip id="tooltip-icon" title="CPA Review" placement="top-start">
                                                                <i className="zmdi zmdi-check"></i>
                                                            </FontTooltip>
                                                            : ''}</td>
                                                        <td onClick={(e) => e.stopPropagation()}>
                                                            <label className="container101">
                                                                <input
                                                                    className="second-check-box"
                                                                    type="checkbox"
                                                                    checked={!!(this.state.SelectALL || (selectedItem.length > 0 && selectedItem.indexOf(item.id) > -1))}
                                                                    onChange={(e) => this.onCheckboxClick(e, item)}
                                                                />
                                                                <span className="checkmark101 green_CheckMark"></span>
                                                            </label>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                            <div className="panel-commentCount" style={{ width: 'auto', display: 'inline-block', margin: 0, verticalAlign: 'middle' }}>
                                                                <img src="/vendors/Vector Smart Object.png" alt="comments" className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} onClick={(e) => this.LoadComments(e, item)}></img>
                                                                {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted" style={{ top: '-10px', right: '-6px', left: 'auto' }}>{item.unreviewCommentCount}</span>}
                                                            </div>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Shape 1.png" alt="link" onClick={(e) => this.onLinkClick(e, item)}></img></td>
                                                    </tr>
                                                    {this.state.editIndex === j && this.state.editData && this.renderEditRows(item, j)}
                                                </React.Fragment>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan="15" align="center">
                                                    No issues here! Keep up the good work!
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <PaginationComponent
                                selectedPageNo={this.state.PageNo}
                                selectedSize={this.state.PageSize}
                                TotalRecords={this.state.TotalRecords}
                                ChangePageSize={this.ChangePageSize}
                                ChangePage={this.ChangePage}
                                CurrentRecords={this.state.MissingData.length}
                            >
                            </PaginationComponent>
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateDescription: state.ReportData.UpdateDescription,
        LEDGER_UPDATE: state.ledgers.LEDGER_UPDATE,
        BATCH_LEDGER_UPDATE: state.ledgers.BATCH_LEDGER_UPDATE,
        accounts: state.accounts.accountsData
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA,
        MARK_IGNORED_DATA,
        Revert_Ignored_DATA,
        UPDATE_DESCRIPTION_DATA,
        IGNORE_VENDOR,
        UNIGNORE_VENDOR,
        LedgerUpdate,
        UpdateBatchNewAccount,
        Accounts
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewInconsistentExpenseCoding);
